export const BUTTON_CONTAINER_BASE_CLASSES = ['flex', 'flex-col'];

export const BUTTON_CONTAINER_VARIANT_CLASSES = {
  popup: ['space-y-2', 'w-full'],
  productDescriptionDesktop: ['items-center', 'space-y-4'],
  productDescriptionMobile: ['md:w-full', 'md:flex-row-reverse']
};

export const BUTTON_VARIANT_CLASSES = {
  productDescriptionDesktop: ['mt-1', 'w-full'],
  productDescriptionMobile: ['md:mr-3']
};
